export default "__VITE_ASSET__Xx9tzmUm__"